import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, frame: String }
  static targets = ["scroller", "leftFade", "rightFade"]

  connect() {
    if (this.hasScrollerTarget) {
      this.boundUpdate = () => this.updateFades()
      this.updateFades()
      window.addEventListener("resize", this.boundUpdate)
    }
  }

  disconnect() {
    if (this.boundUpdate) window.removeEventListener("resize", this.boundUpdate)
  }

  updateFades() {
    if (!this.hasScrollerTarget) return
    const el = this.scrollerTarget
    const canScrollLeft = el.scrollLeft > 1
    const canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    if (this.hasLeftFadeTarget) this.leftFadeTarget.classList.toggle("opacity-0", !canScrollLeft)
    if (this.hasRightFadeTarget) this.rightFadeTarget.classList.toggle("opacity-0", !canScrollRight)
  }

  scrollLeft() {
    if (!this.hasScrollerTarget) return
    this.scrollerTarget.scrollBy({ left: -this.scrollerTarget.clientWidth * 0.7, behavior: "smooth" })
  }

  scrollRight() {
    if (!this.hasScrollerTarget) return
    this.scrollerTarget.scrollBy({ left: this.scrollerTarget.clientWidth * 0.7, behavior: "smooth" })
  }

  select(event) {
    event.preventDefault()
    const segment = event.params.segment || ""
    const url = new URL(this.urlValue, window.location.origin)
    if (segment) {
      url.searchParams.set("segment", segment)
    } else {
      url.searchParams.delete("segment")
    }

    const frame = document.getElementById(this.frameValue)
    if (frame) {
      frame.src = url.toString()
    }

    // NOTE: 一括編集モードの 「割り付け全件一括」 は window.location.search から segment を読むため、
    //       タブ切替時にブラウザ URL 側も同期しておかないと、 別タブを開いた状態で一括適用しても
    //       元の割り付け ( もしくは全件 ) に適用されてしまう。
    const nextUrl = new URL(window.location.href)
    if (segment) {
      nextUrl.searchParams.set("segment", segment)
    } else {
      nextUrl.searchParams.delete("segment")
    }
    window.history.replaceState(window.history.state, "", nextUrl.toString())

    // タブのアクティブ状態を切り替え
    this.element.querySelectorAll("button").forEach(btn => {
      const btnSegment = btn.dataset.segmentTabsSegmentParam || ""
      const isActive = btnSegment === segment
      btn.classList.toggle("bg-indigo-600", isActive)
      btn.classList.toggle("text-white", isActive)
      btn.classList.toggle("bg-gray-100", !isActive)
      btn.classList.toggle("text-gray-600", !isActive)
      btn.classList.toggle("hover:bg-gray-200", !isActive)
    })
  }
}
